import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { proposalInitialState } from 'v3/data/store/proposal/state';
import { IFinancing, IFinancingDetails, IProduct } from 'v3/data/store/proposal/types';

export const proposalSlice = createSlice({
  name: 'proposal',
  initialState: proposalInitialState,
  reducers: {
    setProposalFinancingInformations: (state, action: PayloadAction<IFinancing>) => {
      state.financing = action.payload;
      return state;
    },
    setProposalProductPrice: (state, action: PayloadAction<IProduct>) => {
      state.product = action.payload;
      return state;
    },
    setProposalFinancingDetails: (state, action: PayloadAction<IFinancingDetails>) => {
      state.financingDetails = action.payload;
      return state;
    },
    clearProposalInfo: (state) => {
      state.financing = proposalInitialState.financing;
      state.financingDetails = proposalInitialState.financingDetails;
      state.product = proposalInitialState.product;
      return state;
    },
  },
});
